import {
  SIDEBAR_BADGE_KEY,
  SidebarBadgeKeyType,
} from '../../../../../interfaces/system/SidebarNavConfig';
import { chatStore } from '../../../../../stores/chatStore';
import { unreadScansCountStore } from '../../../../../stores/unreadScansCountStore';

type UseBadgeValueProps = {
  badgeKey?: SidebarBadgeKeyType | null;
};

//Consumer component should be MobX Observer
export const useBadgeValue = ({ badgeKey }: UseBadgeValueProps) => {
  const { scanIqUnreadCount, nutritionUnreadCount } = unreadScansCountStore;
  const { unreadCount } = chatStore;

  if (!badgeKey) {
    return null;
  }

  switch (badgeKey) {
    case SIDEBAR_BADGE_KEY.UNREAD_MESSAGES:
      return unreadCount;
    case SIDEBAR_BADGE_KEY.SCAN_IQ_NEW_SCANS:
      return scanIqUnreadCount;
    case SIDEBAR_BADGE_KEY.NUTRITION_NEW_SCANS:
      return nutritionUnreadCount;
  }
};
